import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAllActivity(year: string) {
  const response = await axios.get(
    `${API_URL}operation/activity/year-totals?year=${year}`
  );
  const data = response.data.doc.data;
  return data;
}
export async function getAllIndicators(filter: any) {
  const params = new URLSearchParams();

  if (filter.init_date) params.set('init_date', filter.init_date);
  if (filter.end_date) params.set('end_date', filter.end_date);
  const response = await axios.get(
    `${API_URL}operation/activity/current?${params.toString()}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function downloadPDF(pdfRoute: string, fileName: string) {
  const date = new Date().toISOString().split('T')[0];

  try {
    const response = await axios({
      url: `${API_URL}${pdfRoute}`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.data) {
        const errorData = await error.response.data.text();
        throw new Error(
          `Error al descargar el PDF: ${
            JSON.parse(errorData).message || 'Desconocido'
          }`
        );
      }
    }
    throw new Error('Error desconocido al descargar el PDF');
  }
}

export async function downloadExcel(excelRoute: string, fileName: string) {
  const date = new Date().toISOString().split('T')[0];

  try {
    const response = await axios({
      url: `${API_URL}${excelRoute}`,
      method: 'GET',
      responseType: 'blob',
    });

    // Tipo correcto para Excel (Office Open XML)
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}-${date}.xlsx`);
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      if (error.response?.data) {
        try {
          const errorData = await error.response.data.text();
          const parsed = JSON.parse(errorData);
          throw new Error(
            `Error al descargar el Excel: ${parsed.message || 'Desconocido'}`
          );
        } catch {
          throw new Error('Error al procesar la respuesta de error.');
        }
      }
    }
    throw new Error('Error desconocido al descargar el Excel');
  }
}

export async function getAllIndicatorAct() {
  const response = await axios.get(`${API_URL}operation/compra-venta/current`);
  const data = response.data.doc.data;
  return data;
}
